import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment'
import {Modal} from 'react-bootstrap';
import Button from './../common/Button'
import TextField from './Textfield';
import DatePicker from 'react-datepicker';
import config from "./../../config";
import "react-datepicker/dist/react-datepicker.css";
import "./DaTable.css";
import Select from "react-select";

const { zonedTimeToUtc, format} = require('date-fns-tz')

const cx = require('classnames');


var imm = require('immutable');

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};

class TableHead extends React.Component {
    render() {
        return (
            <thead>
            <tr>
                {
                    this.props.columns.map(function(cols, i) {
                        if (cols.visible === false) {
                            return;
                        }
                        return <th key={i}>{cols.label}</th>
                    })
                }
            </tr>
            </thead>
        );
    }
}

class TableRow extends React.Component {
    handlePopup(url, fields, footer, title, id) {
        this.props.handlePopup(url, fields, footer, title, id);
    }

    render() {
        var pk = this.props.id;
        const {prefs} = this.props;
        if (this.props.row.hidden === true) {
            return null;
        }

        return (
            <tr key={pk}>
                {this.props.metadata.map(function(col, index) {
                    if (col.visible === false) {
                        return
                    }
                    if (col.type === undefined) {
                        return <td key={index}>{this.props.row[col.source]}</td>
                    } else if (col.type === 'primary') {
                        pk = this.props.row[col.source];
                    } else if (col.type === 'icon') {
                        return <td key={index}><div className={col.classnames[this.props.row[col.source]]}>{col.values[this.props.row[col.source]]}</div></td>
                    } else if (col.type === 'enum') {
                        return <td key={index}>{col.values[this.props.row[col.source]]}</td>
                    } else if (col.type === 'select') {
                        var key = this.props.row[col.source];
                        var meta = this.props.remotemeta[col.source];
                        return <td key={index}>{meta.values[key]}</td>
                    } else if (col.type === 'datetime') {
                        return <td key={index}>{moment(this.props.row[col.source]).format('YYYY-MM-DD HH:mm:ss')}</td>
                    } else if (col.type === 'datetimefull') {
                        const utcTime = zonedTimeToUtc(new Date(this.props.row[col.source]),"UTC");
                        try {
                            return <td key={index}>{utcTime.toLocaleString(prefs.locale,{timeZoneName:'short', timeZone: prefs.tz})}</td>
                        } catch (err) {
                            return <td key={index}>{this.props.row[col.source]}</td>
                        }
                    } else if (col.type === 'date') {
                        return <td key={index}>{moment(this.props.row[col.source]).format('YYYY-MM-DD')}</td>
                    } else if (col.type === 'time') {
                        return <td key={index}>{moment.utc(this.props.row[col.source]*1000).format('HH:mm:ss')}</td>
                    } else if (col.type.startsWith('money')) {
                        var value = parseFloat(this.props.row[col.source]);
                        return <td key={index} className={cx( value <0 ? "danger" : "")}>{value.toFixed(4)}</td>
                    } else if (col.type === 'popup') {
                        return (
                            <td key={index}>
                                <Button
                                    bsStyle="outline-primary"
                                    icon="visibility"
                                    onClick={this.handlePopup.bind(this, col.url, col.fields, col.footer, col.title, pk)}
                                    value={col.label}
                                />
                            </td>
                        )
                    } else if (col.type === 'link') {
                        var url = col.value;
                        url = url.replace('{$id}', pk);
                        return <td key={ index }><Link className="btn btn-view" to={url}>{col.label}</Link></td>
                    } else if (col.type === 'link_href') {
                        var url = col.value;
                        url = url.replace('{$id}', pk);
                        return <td key={ index }><a className="btn btn-view" href={url}>{col.label}</a></td>
                    } else {
                        return <td key={index}>{this.props.row[col.source]}</td>
                    }
                }, this)}
            </tr>
        );
    }
}

class TableBody extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: {data:[]},
            metadata: [],
            idcol: null
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.data.data !== undefined ) {
            this.setState({
                data: nextProps.data
            })
        }
    }
    componentDidMount() {
        var idcol = null;
        this.props.metadata.map(function(col, index) {

            if (col.type === 'primary') {
                idcol = col.source;
            }
        }, this);

        this.setState({
            idcol: idcol
        })
    }
    handlePopup(url, fields, footer, title, id) {
        this.props.handlePopup(url, fields, footer, title, id);
    }
    render() {
        const {prefs} = this.props;
        return(
            <tbody>
            {
                this.state.data.data && this.state.data.data.map(function(datarow, i) {

                    var id = datarow[this.state.idcol];
                    return (
                        <TableRow
                            key={i}
                            id={id}
                            row={datarow}
                            metadata={this.props.metadata}
                            remotemeta = {this.props.data.metadata}
                            handlePopup = { this.handlePopup.bind(this) }
                            prefs = {prefs}
                        />
                    )
                }, this)
            }
            {  this.props.loading &&
                <tr className="loader-animation"/>
            }
            </tbody>
        )
    }
}

class Tfoot extends React.Component {
    render() {
        var data =  this.props.data;
        if (data === undefined || data.length === 0)
            return null;
        return (
            <tfoot>
            {
                this.props.data.map && this.props.data.map(function(datarow, i) {
                    return (
                        <tr key = {i}>
                            {
                                this.props.columns.map(function(datacell, j) {
                                    return (<td key = {j}>{ datarow[datacell.source] }</td>)
                                }, this)
                            }
                        </tr>
                    )
                    }, this)
                }
        </tfoot>
        )
    }
}

class TableFooter extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: true
        }
    }
    componentWillReceiveProps() {
        this.setState({loading: false})
    }
    onLoadMore() {
        this.setState({loading: true}, this.props.onLoadMore())
    }
    render() {
        if (this.props.loadMore === false)
            return null;

        if (this.props.datalen === 0 && this.props.offset === 0 && !this.props.loading) {
            return (<div className="center">No Data</div>)
        }

        var message = this.props.loading ? "Loading..." : "Load More";
        if (this.props.datalen < this.props.limit) {
            return null;
        }
        return (
            this.props.noLoadMoreButton ||
            <div>
                <button className={cx("btn","btn-default","btn-block", this.props.loading ? "disabled" : "" )} onClick= {this.onLoadMore.bind(this)} >{ message }</button>
            </div>
        )
    }
}

class PopupBody extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: [],
            error: '',
            loading: false
        }
    }
    componentDidMount() {
        this.loadFromServer();
    }
    loadFromServer() {
        this.setState({loading: true})
        this.props.childProps.dataProvider.getOne(this.props.url, {id: this.props.id}, this.props).then(
            response => 
            this.setState({
                loading: false,
                data: response.data
            })
        );
    }
    render() {
        const {data} = this.state;
        const {prefs} = this.props;
        return(
            <div>
                <table className='table  table-striped'>
                    <tbody>
                {
                    this.props.fields.map(function (datarow, i) {
                        let value = <div >{data[datarow.source]}</div>;
                        if( datarow.type === 'enum' ) {
                            value = <div>{datarow.values[data[datarow.source]]}</div>;
                        } else if (datarow.type === 'datetimefull') {
                            try {
                                const utcTime = zonedTimeToUtc(new Date(data[datarow.source]),"UTC");
                                value = <div>{utcTime.toLocaleString(prefs.locale,{timeZoneName:'short', timeZone: prefs.tz})}</div>
                            } catch (err) {
                                value = <div>{data[datarow.source]}</div>
                            }
                        }
                        return (
                            <tr id={i} key={i}>
                                <td>
                                    {datarow.label}
                                </td>
                                <td>
                                    { value }
                                </td>
                            </tr>
                        )
                    }, this)
                }
                    </tbody>
                </table>
                <PopupFooter footer= {this.props.footer} fields = {this.props.fields} data = {this.state.data} />
            </div>
        )
    }
}

class PopupFooter extends React.Component {
    handlePopup(url, fields, footer, id) {
        this.setState({
            modalIsOpen: true,
            modalUrl: url,
            modalFields: fields,
            modalFooter: footer,
            modalId: id
        });
    }
    render() {
        if (this.props.footer === undefined)
            return null;

        return (
            <div>
                {
                    this.props.footer.map(function (row, i) {
                        // condition check
                        if (row.condition !== undefined) {
                            if (this.props.data[row.condition.field] !==  row.condition.value) {
                                return null;
                            }
                        }
                        // type check
                        if (row.type === 'button') {
                            var url = row.url;
                            row.urlattrs.map(function (attr, k) {
                                url = url.replace('$' + attr.key, this.props.data[attr.value]);
                            }, this);
                            return (
                                <div key={i}><Link className="btn btn-view" to={ url }>{ row.value }</Link></div>
                            )
                        } else if (row.type === 'table')  {
                            var data = this.props.data[row.source];
                            if (data === undefined)
                                return null;
                            return(
                                <div key={ i }>
                                    <h5>{ row.title }</h5>
                                    <table id={ i } className='table table-bordered table-striped'>
                                        <TableHead columns={ row.fields }/>
                                        <tbody>
                                        {
                                            data.map(function(datarow, i) {
                                                return (
                                                    <TableRow
                                                        key={ i }
                                                        id={ i }
                                                        row={ datarow }
                                                        metadata={ row.fields }
                                                        handlePopup = { this.handlePopup.bind(this) }
                                                    />
                                                )
                                            }, this)
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            )
                        }
                    }, this)
                }
            </div>
        )
    }
}


class Filter extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: imm.Map(),
            loading: true
        }
    }

    componentWillMount() {
        this.loadDefaults();
    }

    loadDefaults() {
        if (this.props.userfilter === undefined)
            return;

        this.props.userfilter.map(function (row, i) {
            if (row.type === 'date_range') {
                if (row.default !== undefined) {
                    this.setState((state) => ({
                        data: state.data.set(row.source + '_from', row.default.from).set(row.source + '_to', row.default.to)
                    }))
                } else {
       //             let val1 = DateTime.fromObject({hour: 0, minute: 0, second: 0, millisecond: 0 });
        //            let val2 = DateTime.fromObject({hour: 23, minute: 59, second: 59, millisecond: 999});
            //        this.setState((state) => ({
             //           data: state.data.set(row.source + '_from', val1).set(row.source + '_to', val2)
              //      }))
                }
            } else if (row.type === 'select') {

            } else {
                if (row.default !== undefined) {
                    this.setState((state) => ({
                        data: state.data.set(row.source, row.default)
                    }))
                }
            }
        }, this);
    }

    handleChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value.format())
        }));
    }
    handleDateRangeFromChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }))
    }
    handleDateRangeToChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }))
    }
    handleSelectChange(key, value) {
        if (value === null) {
            return;
        }
        var val = value.value;
        this.setState((state) => ({
            data: state.data.set(key, val)
        }));
    }
    componentWillReceiveProps() {
        this.setState({loading: false})
    }

    handleFilter() {
        this.setState({loading: true},this.props.onFilter(this.state.data));
    }
    handleClear() {
        this.loadDefaults();
    }
    render() {
        if (this.props.userfilter === undefined)
            return null;
        let csv_link = config.apiGateway.URL + this.props.url;
        if (this.props.urlattrs !== undefined) {
            for (var key in this.props.urlattrs) {
                var repl = '{$' + key + '}';
                csv_link = csv_link.replace(repl, this.props.urlattrs[key]);
            }
        }
        csv_link = csv_link + '?export=1&method=get';
        this.props.userfilter.map(function (row, i) {
            if (row.type === 'date_range') {
                csv_link = csv_link + '&' + row.source + '_from=' + this.state.data.get(row.source + '_from') + '&' + row.source + '_to=' + this.state.data.get(row.source + '_to') ;
            } else {
                csv_link = csv_link + '&' + row.source + '=' + this.state.data.get(row.source);
            }
        }, this);


        return (
            <div className="card">
                <div className="card-body">
                    <form className="form-vertical">
                        <div className="row">
                            <div className="col-lg-12">
                            {
                                this.props.userfilter.map(function (row, i) {
                                    // condition check
                                    var src = row.source;
                                    if (row.type === 'text') {
                                        return (
                                            <div key = {i} className="form-group">
                                                <label
                                                    className="col-sm-2 control-label"
                                                    htmlFor={src}>{row.label}</label>
                                                <div className="col-sm-2 input-group">
                                                    <TextField
                                                        label= ''
                                                        type='text'
                                                        value={ this.state.data.get(src) }
                                                        onChange={ this.handleChange.bind(this, src) }
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                        );
                                    } else if (row.type === 'date_range') {
                                        var d1 = new Date(this.state.data.get(src + '_from'));
                                        var d2 = new Date(this.state.data.get(src +'_to'));
                                        return (
                                            <div key = {i} className="form-group">
                                                <label
                                                    className="col-sm-2 control-label"
                                                    htmlFor={src}>{row.label} from</label>
                                                <div className="col-sm-4 input-group">
                                                    <DatePicker
                                                        className="form-control datepicker"
                                                        selected={ d1 }
                                                        onChange={ this.handleDateRangeFromChange.bind(this, src + '_from') }
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        dateFormat="yyyy-MM-dd HH:mm"
                                                    />
                                                </div>
                                                <div
                                                    className="col-sm-2">to
                                                </div>
                                                <div className="col-sm-4 input-group">
                                                    <DatePicker
                                                        className="form-control datepicker"
                                                        selected={ d2 }
                                                        onChange={ this.handleDateRangeToChange.bind(this, src + '_to') }
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        dateFormat="yyyy-MM-dd HH:mm"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    } else if (row.type === 'select') {
                                        var meta = this.props.data.metadata[row.source];
                                        var options = [];
                                        if (row.options !== undefined) {
                                            if (row.options.empty) {
                                                var options = [{value: 0, label: '--'}];
                                            }
                                        }

                                        var defaultSelect = {value: 0, label: '--'};
                                        if (meta !== undefined) {
                                            Object.keys(meta.values).map(function (i) {
                                                options.push({value: i, label: meta.values[i]});
                                                if (i === this.state.data.get(row.source)) {
                                                    defaultSelect = {value: i, label: meta.values[i]}
                                                }
                                            }, this);
                                        }
                                        return (
                                            <div key={i} className="form-group">
                                                <label
                                                    className="col-sm-2 control-label"
                                                    htmlFor={row.source}>{row.label}</label>
                                                <div className="col-sm-2 input-group">
                                                    <Select
                                                        name={row.source}
                                                        options={options}
                                                        selected={this.state.data.get(row.source)}
                                                        id={row.source}
                                                        placeholder={row.label}
                                                        value={defaultSelect}
                                                        onChange={this.handleSelectChange.bind(this, row.source)}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                }, this)
                            }

                            </div>
                        </div>
                    </form>
                </div>
                <div className="card-footer">
                    <Button bsStyle="outline-success" disabled={this.props.loading}  icon="search" value="Filter" onClick={this.handleFilter.bind(this)}/>
                    <Button bsStyle="white" disabled={this.props.loading} value="Reset" onClick={this.handleClear.bind(this)}/>
                    { this.props.download &&
                    <div
                        type="button"
                        className="btn btn-download pull-right"
                    ><a className="a-btn-download" href={ csv_link }>Export CSV</a></div>
                    }
                </div>
            </div>
        )
    }
}


class DaTable extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modalIsOpen: false,
            modalUrl: false,
            modalFields: [],
            modalFooter: '',
            modalId: 0
        }
    }
    handlePopup(url, fields, footer, title, id) {
        this.setState({
            modalIsOpen: true,
            modalUrl: url,
            modalFields: fields,
            modalFooter: footer,
            modalTitle: title,
            modalId: id
        });
    }
    handleModalCancel() {
        this.setState({
            modalIsOpen: false
        });
    }
    render(){
        let prefs = {};
        if (this.props.childProps !== undefined && this.props.childProps.prefs !== undefined) {
            prefs = this.props.childProps.prefs;
        }
        const {loading} = this.props;
        return (
            <div className="card">
                <Modal show={this.state.modalIsOpen} size="lg" onHide={this.handleModalCancel.bind(this)} style={customStyles}>
                    <Modal.Header closeButton>
                        <Modal.Title>{ this.state.modalTitle }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PopupBody
                            fields = {this.state.modalFields}
                            token_name = {this.props.token_name}
                            url = {this.state.modalUrl}
                            id = {this.state.modalId}
                            footer = {this.state.modalFooter}
                            childProps={this.props.childProps}
                            prefs = {prefs}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button bsStyle="white" value="Close" onClick={this.handleModalCancel.bind(this)}/>
                        </div>
                    </Modal.Footer>
                </Modal>
                <div className="row">
                    <div className="col-lg-12">
                        <Filter
                            userfilter = {this.props.userfilter}
                            onFilter = { this.props.onFilter }
                            loading = { this.props.loading }
                            url = { this.props.url }
                            urlattrs = { this.props.urlattrs }
                            download = { this.props.download }
                            data={this.props.data}
                            prefs = {prefs}
                        />
                    </div>
                </div>
                <div className="row card-body p-0 pb-3 text-center">
                    <div className="col-lg-12">
                        <table id={this.props.id} className='table table-bordered table-striped'>
                            <TableHead columns={this.props.metadata}/>
                            <TableBody
                                data={this.props.data}
                                metadata={this.props.metadata}
                                handlePopup={ this.handlePopup.bind(this) }
                                loading = { this.props.loading }
                                prefs = {prefs}
                            />
                            <Tfoot data = { this.props.footer } columns={this.props.metadata} />
                        </table>
                        <TableFooter
                            onLoadMore = { this.props.onLoadMore }
                            datalen = { this.props.datalen }
                            limit = { this.props.limit }
                            offset = { this.props.offset }
                            loadMore = { this.props.loadMore }
                            loading = { this.props.loading }
                            noLoadMoreButton = { this.props.noLoadMoreButton }
                        />
                    </div>
                </div>
            </div>
        );
    }
};

export default DaTable;
